import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { PassengerPriceDetails } from "../../../Orchestrator/Types/Index";


export class MainOutBoundCheckAction extends BaseAction<void, {
    checked: boolean,
    allOutBoundFulFilledPass: PassengerPriceDetails[],
    passengerIds?: string[]
}> {
    async run(): Promise<void | null> {
        try {
            const { checked, allOutBoundFulFilledPass, passengerIds } = this.params!;
            if (checked == true) {
                if (passengerIds && passengerIds.length > 0) {
                    updateRecoilState("selectedPassengerForCancelAtom", passengerIds);
                    const selectedPassengerPrices = allOutBoundFulFilledPass.filter(p =>
                        passengerIds.includes(p.pId.toString())
                    );
                    updatePaymentItems(selectedPassengerPrices, "paymentOutBoundItemsDetailsAtom");
                } else {
                    updateRecoilState("selectedPassengerForCancelAtom", allOutBoundFulFilledPass.map((d) => d.pId));
                    updatePaymentItems(allOutBoundFulFilledPass, "paymentOutBoundItemsDetailsAtom");
                }
            }
            else {
                updateRecoilState("selectedPassengerForCancelAtom", []);
                updatePaymentItems([], "paymentOutBoundItemsDetailsAtom");
            }

        } catch (error) {
            console.error("Error in PassengerOutboundCheck action.:", error);
        }
    }
}

const updatePaymentItems = (outBoundPassengerPriceList: any, atomKey: string) => {
    let allOutBoundInfantCount = 0
    let allOutBoundChildrenCount = 0
    let allOutBoundAdultCount = 0
    let allStudentCount = 0
    let allOutBoundSeniorCitizenCount = 0
    let allWheelchairCount = 0
    let allReducedMobilityCount = 0
    outBoundPassengerPriceList.forEach((p: any) => {
        if (p.pType === "Infant") allOutBoundInfantCount++
        if (p.pType === "Children") allOutBoundChildrenCount++
        if (p.pType === "Student") allStudentCount++
        if (p.pType === "Adult") allOutBoundAdultCount++
        if (p.pType === "Senior Citizen") allOutBoundSeniorCitizenCount++
        if (p.pType === "Wheelchair") allWheelchairCount++
        if (p.pType === "People with Reduced Mobility") allReducedMobilityCount++
    })
    const outBoundPassengerDetails = []
    if (allOutBoundAdultCount > 0) outBoundPassengerDetails.push({
        description: `${allOutBoundAdultCount} Adult`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Adult")?.pValue || 0) * allOutBoundAdultCount
    })
    if (allOutBoundChildrenCount > 0) outBoundPassengerDetails.push({
        description: `${allOutBoundChildrenCount} Children`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Children")?.pValue || 0) * allOutBoundChildrenCount
    })
    if (allOutBoundInfantCount > 0) outBoundPassengerDetails.push({
        description: `${allOutBoundInfantCount} Infant`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Infant")?.pValue || 0) * allOutBoundInfantCount
    })
    if (allOutBoundSeniorCitizenCount > 0) outBoundPassengerDetails.push({
        description: `${allOutBoundSeniorCitizenCount} Senior Citizen (UAE)`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Senior Citizen")?.pValue || 0) * allOutBoundSeniorCitizenCount
    })
    if (allStudentCount > 0) outBoundPassengerDetails.push({
        description: `${allStudentCount} Student`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Student")?.pValue || 0) * allStudentCount
    })
    if (allReducedMobilityCount > 0) outBoundPassengerDetails.push({
        description: `${allReducedMobilityCount} People with Reduced Mobility`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "People with Reduced Mobility")?.pValue || 0) * allReducedMobilityCount
    })
    if (allWheelchairCount > 0) outBoundPassengerDetails.push({
        description: `${allWheelchairCount} Wheelchair`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Wheelchair")?.pValue || 0) * allWheelchairCount
    })

    if (atomKey === "paymentOutBoundItemsDetailsAtom")
        updateRecoilState(atomKey, outBoundPassengerDetails)
    if (atomKey === "paymentInboundItemsDetailsAtom")
        updateRecoilState(atomKey, outBoundPassengerDetails)
}

export const mainOutBoundCheckAction = new MainOutBoundCheckAction();